import styled from 'styled-components';
import { Text } from 'components/Text';
import { Box, Flex } from 'components/Box'
import Container from 'components/layout/Container';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { InputFieldStyle } from 'views/Forms/FormsStyled';
import { CryptoBox } from 'views/Landing/Components/WinningBonus/GamesEnabledCryptos/GamesEnabledCryptosStyled';
import { FlexComponentSpaceBetween } from 'components/Box/AllFlexComponentStyle';
import HeroBG from 'assets/Hero/HeroBG-1.svg';
import WithdrawValue from 'assets/Buttons/WithdrawValue.svg';
import CashoutWithdrawButton from 'assets/Buttons/WithdrawCashOutIcon.svg';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

export const WithdrawMobileScreen = styled(FlexComponentSpaceBetween)`
    ${({ theme }) => theme.mediaQueries.xs} {
        display: none;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        display: none;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        display: flex;
    }
`

export const ProfileBackground = styled.div`
    width:100%;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    display:flex;
    align-items: center;

    ${({ theme }) => theme.mediaQueries.xs} {
        height: 70px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        height: 92px;
    }
`
export const ContainerWidth = styled(Container)`
    ${({ theme }) => theme.mediaQueries.xs} {
        width:100%;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        width:100%;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        max-width:65%;
    }
`
export const ContainerGamesListWidth = styled(Container)`
    max-width:100%;
`

export const BgImg = styled(Box)`
    background-image: url(${HeroBG});
    background-size: cover;
    padding-bottom: 50px;
    background-position: bottom;
`

export const BackIconWidth = styled(Flex)`
    width: 45%;

    ${({ theme }) => theme.mediaQueries.xs} {
        padding: 0px 0px 0px 15px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
       padding: 0px 0px 0px 35px;
    }
`
export const HeadingProfileColor = styled(Text)`
    text-align:center;
    
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 18px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 50px 0px;
        font-weight: 800;
        font-size: 40px;
        line-height: 55px;
    }
`
export const HeadingWithdrawProfile = styled(Text)`
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 18px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 20px 0px 0px 0px;
        font-weight: 800;
        font-size: 40px;
        line-height: 55px;
    }
`
export const HeadingWithdrawAmount = styled(Box)`
    text-align:center;
    span{
        font-weight: 500;
        font-size: 20px;
    }
`
export const UserProfile = styled(Flex)`
    align-items:center;
    padding:25px 0px;
`

export const UserProfileImage = styled(Flex)`
    justify-content:center;
    align-items:center;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    border: 4px solid ${(props) => props.theme.colors.borderColor};
    ${({ theme }) => theme.mediaQueries.xs} {
        flex-direction:row;
        width: 52px;
        height: 52px;
    } 
    ${({ theme }) => theme.mediaQueries.sm} {
        flex-direction:row;
        width: 80px;
        height: 80px;
    } 
    ${Text} {
        font-weight: 600;
        font-size: 30px;
        line-height: 43px;
    }
`
export const UserProfileDetails = styled(Box)`
    margin-left:25px;
    a{
        width: 25px;
        height: 25px;
        margin: 0px 10px;
    }
`

export const UserName = styled(Text)`
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 16px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 20px;
        line-height: 27px;
        font-weight: 500;
    }
`

export const UserCash = styled(Text)`
    color: ${(props) => props.theme.colors.primary};


    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 18px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 6px 0px;
        font-size: 24px;
        font-weight: 800;
        line-height: 33px;
    }
`

export const UserPayment = styled(Text)`
color: ${(props) => props.theme.colors.footerLink};
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 16px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
    }
`

export const EditImageStyle = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.xs} {
        align-items: center;
    }    
`

export const StyledTabs = styled(TabsPrimitive.Root)`
    margin-top: 25px;
`;

export const StyledList = styled(TabsPrimitive.List)`
    flex-shrink: 0;
    display: flex;
    width:100%;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    height: 92px;
`;

export const StyledTrigger = styled(TabsPrimitive.Trigger)`
    all: unset;
    margin: 0px 30px;
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 26px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.text};
    user-select: none;

    :hover, :active, :focus{ 
        color: ${(props) => props.theme.colors.primary};
        border-bottom: 3px solid ${(props) => props.theme.colors.primary};
    }

    &[data-state="active"]{
        color: ${(props) => props.theme.colors.primary};
        border-bottom: 3px solid ${(props) => props.theme.colors.primary};
    }
}
`;

export const StyledContent = styled(TabsPrimitive.Content)`
    display: flex;
    text-align: center;
    flex-direction: column;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    margin: 40px 0px;
    height: 550px;

    tr{
        border-style:hidden;

        :nth-of-type(2n+1) > *{
            color: ${(props) => props.theme.colors.text} !important;
        }
    }

    th{
        color: ${(props) => props.theme.colors.text};
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
    }

    td{
        color: ${(props) => props.theme.colors.text};
    }
`;

export const AmountInformation = styled(Flex)`
    background-image: url(${WithdrawValue});
    background-position: 100% 100%;
    background-repeat: no-repeat;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 9px auto;
    height: 80px;

    ${({ theme }) => theme.mediaQueries.xs} {
        width:100%;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        width:50%;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        width: 264px;
    }
`
export const AmountInforValueName = styled(Text)`
    color: ${(props) => props.theme.colors.text};
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
`
export const AmountInforValue = styled(Text)`
    color: ${(props) => props.theme.colors.text};
    font-weight: 800;
    font-size: 24px;
    line-height: 33px;
`

export const TimeToCashOut = styled(Box)`
    ${Text}{
        ${({ theme }) => theme.mediaQueries.xs} {
            font-size: 16px;
            line-height: 23px;
        }    
        ${({ theme }) => theme.mediaQueries.sm} {
            font-size: 20px;
            line-height: 27px;
        }
    }
`

export const Fieldset = styled('fieldset')`
    all: unset;
    margin: auto;
    // width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    // padding: 30px 0px;
`;

// export const Label = styled('label')`
//     font-size: 13px;
//     line-height: 1;
//     margin-bottom: 10px;
//     color: ${(props) => props.theme.colors.imgBackgroundColor};
//     display: block;
//     text-align: start;
// `;

// export const InputHeight = styled(LoginFormStyle)`
//     marging: 15px 0px;
// `;

export const InputField = styled(InputFieldStyle)`
    margin: 20px 0px;
    display: flex;
    flex-direction: column;
    width: 100%;

    input{
        background:rgb(201,87,255, 0.15);
        border-radius: 0px;
        height: 60px;
        border: none;
    }
    label{
        color: ${(props) => props.theme.colors.text};
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 500;
        text-align: start;
    }
    .form-control{
        color: ${(props) => props.theme.colors.text};
    }
    .form-control:focus {
        color: ${(props) => props.theme.colors.text};
        background-color: ${(props) => props.theme.colors.imgBackgroundColor};
        box-shadow: none;
    }
`;

export const ButtondStyle = styled(InputFieldStyle)`
    button{
        all: unset;
        background-image:url(${CashoutWithdrawButton});
        background-repeat: no-repeat;
        font-weight: 500;
        font-size: 18px;
        width: 100%;
        height: 60px;
        color: ${(props) => props.theme.colors.text};
    }
`;

export const InviteFriendsHeading = styled(Text)`
    margin-top: 30px;

    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 16px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 28px;
        font-weight: 800;
        line-height: 38px;
    }
`

export const ShareTheRefrral = styled(Text)`
    color: ${(props) => props.theme.colors.gamefiSubHeadingColor};
    width: 75%;
    margin: 10px auto;
    text-align: center;

    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 18px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 24px;
        font-weight: 500;
    }
`

export const NewsletterButton = styled(InputField)`
    display:flex;
    margin: 40px auto 15px auto;
    align-items: center;
    position: relative;

    ${({ theme }) => theme.mediaQueries.xs} {
		width: 100%;
    }${({ theme }) => theme.mediaQueries.sm} {
		width: 50%;
    }
    ${({ theme }) => theme.mediaQueries.md} {
		width: 60%;
    }
    & Button{
        width:auto;
        position: absolute;
        border-radius: 0px;
        box-shadow: none;
        margin: 7px 0px;
        padding: 0px;

        ${({ theme }) => theme.mediaQueries.xs} {
            height: 35px;
            right: 7px;
        }
        ${({ theme }) => theme.mediaQueries.sm} {
            height: 45px;
            right: 15px;
        }
    }
`

export const FriendsRefferedDiv = styled(Flex)`
    justify-content: end;
    margin: 0 auto;

    ${({ theme }) => theme.mediaQueries.xs} {
		width: 100%;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 60%;
    }

`
export const FriendsReffered = styled(Text)`
    ${({ theme }) => theme.mediaQueries.xs} {
		font-size: 14px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 16px;
    }
`

export const FriendsRefferedValue = styled(Text)`
    color: ${(props) => props.theme.colors.primary};
    font-size: 16px;
    padding-left: 10px;
`

export const SocialIcons = styled(Text)`
    margin: 25px auto;
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: ${(props) => props.theme.colors.text};

    & a{
        margin: 20px 7px;
    }

    ${Text}{ 
		font-size: 16px;
        margin-bottom: 15px;
    }
`

export const TokenWithdrawGamefiHeading = styled(ProfileBackground)``

export const TokenWithdrawGamefiHeadingCenter = styled(HeadingProfileColor)`
    margin: auto;
    font-size: 28px;
    font-weight: 500;
    width: 300px;
    line-height: 38px;
`
export const ChooseTokenToWithdraw = styled(TokenWithdrawGamefiHeading)`
    margin-top: 30px;
    flex-direction: column;
    height: auto;
    padding: 70px 0px;
`
export const WithdrawCryptoBox = styled(CryptoBox)`
    background-color:#02052E;
    width: 120px;
    height: 120px;
    border-radius: 20px;

    & img{
        width: 72px;
        height: 72px;
    }
`
export const WithdrawChooseImagePadding = styled(Flex)`
    justify-content: space-evenly;
    flex-direction: column;

    ${({ theme }) => theme.mediaQueries.xs} {
        padding: 20px 10px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        padding: 50px 10px;
    }
`
export const WithdrawTextStyle = styled(Text)`
    text-align: center;
    font-size: 20px;

    ${({ theme }) => theme.mediaQueries.xs} {
        padding-top: 10px;
    }    
    ${({ theme }) => theme.mediaQueries.sm} {
        padding-top: 25px;
    }
`

export const PleaseChooseToken = styled(Flex)`
    flex-wrap: wrap;
    justify-content: center;
`
export const WithdrawRadioStyle = styled(Flex)`
    align-items: center;
    ${Text}{
        margin: 0px 20px;
    }
`

export const WithdrawGameList = styled(Flex)`
    align-content: center;
    justify-content: center;

    & tr{
        border: none;
        background: ${(props) => props.theme.colors.imgBackgroundColor};
        justify-content: space-between;
        align-content: center;
        width: 100%;
        display: flex;
        border-bottom: none;
        margin-bottom: 15px;
    }
    .table > :not(caption) > * > *{
        border-bottom: none;
        box-shadow: none;
        background-color: none;
    }
    & td{
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${(props) => props.theme.colors.text};
    }
`
export const StyledRadio = styled(RadioGroupPrimitive.Item)`
    all: unset;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    width: 25px;
    height: 25px;
`;

export const StyledIndicator = styled(RadioGroupPrimitive.Indicator)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;
`;

// Exports
export const RadioGroup = RadioGroupPrimitive.Root;
export const RadioGroupRadio = StyledRadio;
export const RadioGroupIndicator = StyledIndicator;